/* eslint-disable simple-import-sort/imports */
// import ACEW from "assets/images/game/Slot/slot-acew.png";
import CQ9 from "assets/images/game/Slot/slot-cq9.png";
import FC from "assets/images/game/Slot/slot-fc.png";
import HB from "assets/images/game/Slot/slot-hb.png";
import IBEX from "assets/images/game/Slot/slot-ibex.png";
import JDB from "assets/images/game/Slot/slot-jdb.png";
import JILI from "assets/images/game/Slot/slot-jili.png";
import KA from "assets/images/game/Slot/slot-ka.png";
import PGS from "assets/images/game/Slot/slot-pgs.png";
import PP from "assets/images/game/Slot/slot-pp.png";
import RT from "assets/images/game/Slot/slot-rt.png";
import SG from "assets/images/game/Slot/slot-sg.png";
import MG from "assets/images/game/Slot/mg.png";
import NT from "assets/images/game/Slot/netent.png";
import ACE from "assets/images/game/Slot/slot-acew.png";
import RG from "assets/images/game/Slot/relax gaming.png";
import OEP from "assets/images/game/Slot/EVOplay.png";
import ALI from "assets/images/game/Slot/allize.png";
import BNG from "assets/images/game/Slot/BNG.png";
import BGM from "assets/images/game/Slot/slot-big.webp";
import NLC from "assets/images/game/Slot/nolimit city.png";
import { SubGameType } from "types/game";

export const listGameSlots: SubGameType[] = [
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "IBEX",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: IBEX
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "JILI",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: JILI
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "PP",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: PP
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "PGS",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: PGS
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "HB",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: HB
  },

  // {
  //   game_code: "0",
  //   name: "Lobby",
  //   provider_code: "ACEW",
  //   type: "SL",
  //   featured: "NO",
  //   new_arrive: "NO",
  //   picture: ACEW
  // },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "OJDB",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: JDB
  },

  {
    game_code: "0",
    name: "Lobby",
    provider_code: "CQ9",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: CQ9
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "ORT",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: RT
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "KA",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: KA
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "SG",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: SG
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "FC",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: FC
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "OMG",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: MG
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "ONT",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: NT
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "ACEM",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: ACE
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "ORG",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: RG
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "OEP",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: OEP
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "OAL",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: ALI
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "OBNG",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: BNG
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "OBTG",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: BGM
  },
  {
    game_code: "0",
    name: "Lobby",
    provider_code: "ONLC",
    type: "SL",
    featured: "NO",
    new_arrive: "NO",
    picture: NLC
  }
];
